(function () {
    'use strict';
    var controllerId = 'cndPCorsoAssign';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '_', 'datacontext', 'partecipazioneId', 'corsi', 'isSuper', cndPCorsoAssign]);

    function cndPCorsoAssign($scope, $uibModalInstance, _, datacontext, partecipazioneId, corsi, isSuper) {
        $scope.record = {};
        $scope.corsi = corsi;
        $scope.isSuper = isSuper;
        //console.info('$scope.corsi', $scope.corsi);

        if (partecipazioneId) {
            $scope.partecipazioneId = partecipazioneId;
        }

        $scope.checkAll = function () {
            if ($scope.selectedAll) {
                $scope.selectedAll = true;
            } else {
                $scope.selectedAll = false;
            }
        };

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = [];
                $("input:checkbox[name=listId]:checked").each(function () {
                    var rec = {};

                    var id = $(this).val();
                    var entity = _.find($scope.corsi, function (item) {
                        return item.Id == id;
                    });
                    //console.info('_find', entity);

                    rec = entity;
                    rec.PartecipazioneId = $scope.partecipazioneId;

                    result = addItem(rec);
                });
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            //console.info('addItem', item);
            return datacontext.pCorso_assign(item).then(function (data) {
                return data;
            });
        }
    }
})();